/* Sold-out products last, across the whole collection.

   Shopify cannot sort a collection by stock, but it can filter one, and the
   two filtered lists come back in the collection's own relevance order. So the
   in-stock products are numbered first and the sold-out ones after them, and
   this page takes its slice of that combined list: page 1 is in-stock page 1,
   and the page where the in-stock products run out is the last of them
   followed by the first sold-out ones. The slices are fetched through Section
   Rendering, which returns the collection section and nothing else.

   sections/collection.liquid only switches this on in the default view, with
   the counts from the availability filter, and holds the grid back until it
   is done. Whatever goes wrong here, the grid the page was drawn with is
   shown as it is. It is never left half-replaced or empty. */
(function () {
  var root = document.querySelector('[data-sold-out-last]');
  if (!root) return;

  function reveal() {
    root.removeAttribute('data-sold-out-pending');
  }

  function number(name) {
    return parseInt(root.getAttribute(name), 10) || 0;
  }

  function isCard(element) {
    return !!element.querySelector('a[href*="/products/"]');
  }

  var grid = root.querySelector('[data-products-grid] > .grid');
  var sectionId = root.getAttribute('data-section-id');
  var page = number('data-page');
  var perPage = number('data-per-page');
  var total = number('data-total');
  var inStock = number('data-in-stock');
  var soldOut = number('data-sold-out');

  /* A product with one variant in stock and another sold out is in both
     lists, and the slices would no longer add up. The catalogue has hardly
     any variants, so a collection where that happens just keeps its normal
     order. The same goes for a grid that holds anything but product cards. */
  if (!grid || !sectionId || !perPage || inStock + soldOut !== total) return reveal();
  for (var c = 0; c < grid.children.length; c++) {
    if (!isCard(grid.children[c])) return reveal();
  }

  var start = (page - 1) * perPage;
  var end = Math.min(page * perPage, total);
  if (start >= end) return reveal();

  var wanted = [];
  for (var i = start; i < end; i++) {
    var soldOutSide = i >= inStock;
    var index = soldOutSide ? i - inStock : i;
    wanted.push({
      availability: soldOutSide ? 0 : 1,
      page: Math.floor(index / perPage) + 1,
      at: index % perPage
    });
  }

  var requests = {};

  function cardsFrom(availability, listPage) {
    var key = availability + ':' + listPage;
    if (!requests[key]) {
      var url =
        window.location.pathname +
        '?filter.v.availability=' + availability +
        '&page=' + listPage +
        '&section_id=' + encodeURIComponent(sectionId);

      requests[key] = window
        .fetch(url, {credentials: 'same-origin'})
        .then(function (response) {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var list = doc.querySelector('[data-products-grid] > .grid');
          if (!list) throw new Error('no grid');
          return Array.prototype.filter.call(list.children, isCard);
        });
    }
    return requests[key];
  }

  Promise.all(wanted.map(function (slot) {
    return cardsFrom(slot.availability, slot.page);
  }))
    .then(function (lists) {
      var cards = wanted.map(function (slot, n) {
        return lists[n][slot.at];
      });

      /* A slice that came back short means the lists changed between the page
         and the requests, a sale in the meantime. Better the normal order
         than a gap. And if the fallback has already shown the grid, the
         customer is looking at it, so it stays as it is. */
      if (cards.some(function (card) { return !card; })) return;
      if (!root.hasAttribute('data-sold-out-pending')) return;

      var fresh = cards.map(function (card) {
        var copy = document.importNode(card, true);

        /* The cards fade in through the theme's scroll animation, which only
           knows the cards it found when the page loaded. The grid has been
           hidden until now, so they simply appear. */
        copy.removeAttribute('data-aos');
        Array.prototype.forEach.call(copy.querySelectorAll('[data-aos]'), function (node) {
          node.removeAttribute('data-aos');
        });
        return copy;
      });

      grid.replaceChildren.apply(grid, fresh);
    })
    .catch(function () {
      /* the grid the page was drawn with stays */
    })
    .then(reveal);
})();
